
import { defineComponent, ref, computed } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    message: { type: Object, required: false, default: undefined },
    open: { type: Boolean, required: false, default: true },
  },
  setup(props) {
    const today = new Date().toISOString()
    const isOpen = ref(props.open)
    const shouldDisplay = computed(() => {
      // Check if there is anything to display
      if (!props.message?.message) {
        return false
      }

      const startDate = props.message?.startDate ? new Date(props.message.startDate) : undefined
      const endDate = props.message?.endDate ? new Date(props.message.endDate) : undefined
      const currentDate = new Date()

      // Filter based on optional startDate
      if (startDate && currentDate < startDate) {
        return false
      }

      // Filter based on optional endDate
      if (endDate && currentDate > endDate) {
        return false
      }

      return true
    })

    return { today, isOpen, shouldDisplay }
  },
})
